var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Tabs")]),_vm._v(" "),_c('el-tabs',{staticStyle:{"width":"500px","margin-left":"50%","transform":"translateX(-50%)"},attrs:{"type":"border-card"}},_vm._l((_vm.pageData),function(item){return _c('el-tab-pane',{key:item.id,attrs:{"label":item.name}},[_c(item.content,{tag:"component",attrs:{"itemData":item.data}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f2a9ebd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestTab.vue
// module id = null
// module chunks = 